import { render, staticRenderFns } from "./date-picker-input.vue?vue&type=template&id=3065560a&lang=pug&"
import script from "./date-picker-input.vue?vue&type=script&lang=ts&"
export * from "./date-picker-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports